// ═══════════════════════════════════════════════════════════════════
//  modules/erp/boux.js
//  BOUX_VARIETIES · BOUX_MAX_XP · BOUX_LEVEL_XP
// ═══════════════════════════════════════════════════════════════════

// ═══════════════════════════════════════════════════════════════════════
//  MODULE BOUX — collection de créatures (ERP joueur)
//  Lecture seule : tables boxoria_boux / boxoria_boux_state (plugin Boux).
//  ⚠️ Les actions staff sont en attente de validation de Brice —
//  aucune table boxoria_boux_actions n'est créée tant que la liste
//  d'actions n'est pas validée. Boutons UI uniquement (désactivés).
// ═══════════════════════════════════════════════════════════════════════
export const BOUX_VARIETIES = [
  { key: 'Eau',        label: 'Boux Eau',        emoji: '💧', type: 'primordial', color: '#4F8EF7' },
  { key: 'Feu',        label: 'Boux Feu',        emoji: '🔥', type: 'primordial', color: '#F85149' },
  { key: 'Terre',      label: 'Boux Terre',      emoji: '🌿', type: 'primordial', color: '#3DDC84' },
  { key: 'Air',        label: 'Boux Air',         emoji: '💨', type: 'primordial', color: '#E3B341' },
  { key: 'Magie',      label: 'Boux Magie',      emoji: '✨', type: 'primordial', color: '#BC8CFF', special: true },
  { key: 'Vapeur',     label: 'Boux Vapeur',     emoji: '🌫️', type: 'hybride',    color: '#7D8590', fusion: ['Eau','Feu'] },
  { key: 'Lave',       label: 'Boux Lave',       emoji: '🌋', type: 'hybride',    color: '#E3B341', fusion: ['Feu','Terre'] },
  { key: 'Poussière',  label: 'Boux Poussière',  emoji: '🟤', type: 'hybride',    color: '#C9A84C', fusion: ['Terre','Air'] },
  { key: 'Glace',      label: 'Boux Glace',      emoji: '❄️', type: 'hybride',    color: '#4F8EF7', fusion: ['Air','Eau'] },
];

export const BOUX_MAX_XP = 640;

export const BOUX_LEVEL_XP = [0, 0, 30, 80, 150, 250, 350, 460, 530, 590, 640];
